<div class="header">
    <span> Booking Details </span>
</div>
<button matTooltip="Download Quote" matTooltipPosition="left" class="editRequest downloadQuoteBtn" mat-icon-button
        *ngIf="requestService.selectedRequest?.status?.dev_name!='accepted_by_internal_user' && requestService.selectedRequest?.status?.dev_name!='received'"
        (click)="downloadQuote(emptyRepoQuoteTableService.baseQuote)">
    <i class="flaticon-download"></i>
</button>

<ng-container *ngIf="isQuotation">
    <div class="container">
        <div class="labelSet" fxFlex="30">
            <span class="titleL">Commercials</span>
            <span class="label">Quantity*</span>
            <span class="label">POL*</span>
            <span class="label">POD*</span>
            <span class="label">Payee*</span>
            <!--            <span class="label">Involves only Inland Haulage*</span>-->
            <span class="label">Quote Remarks</span>
        </div>
        <div fxFlex="67" class="valueSetBox">
            <div class="valueSet" fxFlex="14.7em"
                 *ngFor="let quote of quoteList | orderRequirements: 'container_size_type':'display':'asc'; let i = index">
                <span class="valueSetTitle">{{ quote.container_size_type?.display }}</span>
                <app-number-field [isEditable]="negotiate" [placeholder]="'Quantity'" class="w-100i"
                                  [(ngModel)]="quote.quantity" [containerNum]="true" [noDecimal]="true"
                                  [maxlength]="4" (ngModelChange)="calculateCharges(quote)"
                                  [(errors)]="emptyRepoQuoteTableService.baseQuote.error?.quote_items[i].quantity"
                                  [minValue]="1">
                </app-number-field>
                <!--                <app-mat-auto-search [isEditable]="negotiate" [displayField]="'value'" [name]="'name'"-->
                <!--                                     [(ngModel)]="quote.container_condition" [idField]="null"-->
                <!--                                     [listUrl]="containerConditionLists"-->
                <!--                                     [setSearchValue]="false" class="w-100i"-->
                <!--                                     [(errors)]="emptyRepoQuoteTableService.baseQuote.error?.quote_items[i].container_condition">-->
                <!--                </app-mat-auto-search>-->
                <app-mat-auto-search [(ngModel)]="quote.pol_list"
                                     [(errors)]="emptyRepoQuoteTableService.baseQuote.error?.quote_items[i].pol_list"
                                     [isEditable]="negotiate"
                                     [idField]="null" displayField='name_display' [trim]="true" [multiple]="true"
                                     [defaultChip]="false" [clearable]="true" [closeOnSelect]="false"
                                     [clearSearchOnAdd]="true"
                                     [listUrl]="location_url" name="pods" fxLayout="column"
                                     class="w-100i locations"
                                     [class.hidden]="i!=0">
                </app-mat-auto-search>
                <app-mat-auto-search [(ngModel)]="quote.pod_list"
                                     [(errors)]="emptyRepoQuoteTableService.baseQuote.error?.quote_items[i].pod_list"
                                     [isEditable]="negotiate"
                                     [idField]="null" displayField='name_display' [trim]="true" [multiple]="true"
                                     [defaultChip]="false" [clearable]="true" [closeOnSelect]="false"
                                     [clearSearchOnAdd]="true"
                                     [listUrl]="location_url" name="pods" fxLayout="column"
                                     class="w-100i locations"
                                     [class.hidden]="i!=0">
                </app-mat-auto-search>
                <div style="flex: 1 1 100%; max-height: 45px; min-height:45px; padding-top:4px"
                     [class.hidden]="i!=0">
                    <mat-chip color="primary" selected>{{ requestDetails?.requestor?.company?.trade_name }}
                    </mat-chip>
                </div>
                <!--                <div style="flex: 1 1 100%; max-height: 45px; min-height:45px; padding-top:4px">-->
                <!--                    <mat-button-toggle-group [(ngModel)]="quote.inland_haulage" fxLayout="row"-->
                <!--                                             class="w-100i locations togglebtn1" [class.hidden]="i!=0">-->
                <!--                        <mat-button-toggle [value]="true">Yes</mat-button-toggle>-->
                <!--                        <mat-button-toggle [value]="false">No</mat-button-toggle>-->
                <!--                    </mat-button-toggle-group>-->
                <!--                </div>-->
                <app-text-field [isMultiline]="true" [isEditable]="negotiate" [class.hidden]="i!=0"
                                [disabled]="i!=0" class="w-100i" fxLayout="column"
                                [(ngModel)]="emptyRepoQuoteTableService.baseQuote.remarks" [name]="'remarks'"
                                [(errors)]="emptyRepoQuoteTableService.baseQuote.error.remarks">
                </app-text-field>

                <!--                <app-mat-auto-search [isEditable]="true" [displayField]="'currency_code'" [setSearchValue]="false"-->
                <!--                                     [name]="'currency_code'"-->
                <!--                                     [(ngModel)]="currency_code" [idField]="'currency_code'"-->
                <!--                                     (ngModelChange)="updateChargesCurrency()"-->
                <!--                                     [listUrl]="currencyMaster_url+'currency/?currency_code=::search::'">-->
                <!--                </app-mat-auto-search>-->
            </div>
        </div>
    </div>
    <div fxLayout="column" class=" justify-content-start align-items-end gap-2 ">
        <div fxLayout="row" class=" HeaderSet w-100 ">
            <div fxLayout="row " class="justify-content-between gap-2 editHead p-r-5 ">
                <span>Charges</span>
                <div fxLayout="row" class="gap-4 align-items-center">
                    <app-mat-auto-search [beLight]="true" [isEditable]="true"
                                         [(ngModel)]="charge"
                                         [ngModelOptions]="{standalone: true}" [name]="'charge'"
                                         [searchable]="false"
                                         [labelItemTemplate]="userChargeSelectedItem"
                                         [itemTemplate]="userChargeItem"
                                         [idField]="null"
                                         [options]="quoteChargesList"
                                         fxLayout="column" fxFlex="15em">
                    </app-mat-auto-search>
                    <app-mat-auto-search [beLight]="true" [isEditable]="true"
                                         [(ngModel)]="requirement"
                                         [ngModelOptions]="{standalone: true}" [name]="'requirement'"
                                         [searchable]="false"
                                         [labelItemTemplate]="requirementSelectedItem"
                                         [itemTemplate]="requirementItem"
                                         [idField]="null"
                                         [options]="quoteList"
                                         fxLayout="column" fxFlex="15em">
                    </app-mat-auto-search>
                    <button mat-raised-button class="addBtn sleekBtn" [disabled]="!negotiate"
                            (click)="addNewCharge()"
                            matTooltip="Add new Charge" matTooltipPosition="left" matTooltipHideDelay="2000">+ New
                        Charge
                    </button>
                </div>
            </div>
        </div>
        <div class="setTable " [ngClass]="isCustomer ?'empty-repo-charge-table-long':'empty-repo-charge-table'"
             [class.d-none]="chargesDataSource.data.length == 0">
            <mat-table [dataSource]="chargesDataSource">
                <ng-container matColumnDef="charge_name">
                    <mat-header-cell *matHeaderCellDef>Charge</mat-header-cell>
                    <mat-cell *matCellDef="let data; let index = index">
                        <div fxLayout="column" class="align-items-flex-start">
                            <span>
                                {{ data.charge_name?.charge?.charge_head }}
                                <button *ngIf="data.custom == 1"
                                        mat-icon-button class="delete-button" matTooltip="Delete"
                                        matTooltipPosition="right"
                                        color="warn" (click)="deleteCharge(index, data)">
                                <i class="flaticon-delete"></i>
                            </button>
                            </span>
                            <mat-chip class="secondary-chip sleek-chip m-b-5 ">{{ data.basis }}</mat-chip>
                        </div>
                    </mat-cell>
                    <mat-footer-cell *matFooterCellDef="let data"></mat-footer-cell>
                </ng-container>
                <ng-container matColumnDef="requirement">
                    <mat-header-cell *matHeaderCellDef>Req</mat-header-cell>
                    <mat-cell *matCellDef="let data; let index = index">
                                <span>{{
                                        data.requirement != null ?
                                            (data.requirement?.quantity + '*' +
                                                data.requirement?.container_size_type?.display) : '-'
                                    }}</span>
                    </mat-cell>
                    <mat-footer-cell *matFooterCellDef="let data"></mat-footer-cell>
                </ng-container>
                <ng-container matColumnDef="rec_amount">
                    <mat-header-cell *matHeaderCellDef>Rec Amt/Qty</mat-header-cell>
                    <mat-cell *matCellDef="let data; let index = index" style="overflow: visible;">
                        <span>
<!--                            {{ data.rec_amount + ' ' + data.rec_currency }}-->
                            <logzy-money-field [isEditable]="true" [(amount)]="data.rec_amount"
                                               [minValue]="0" (amountChange)="setRecTotal(data)"
                                               [maxValue]="999999999" [(currencyCode)]="data.rec_currency"
                                               (currencyCodeChange)="updateChargesCurrency(data)"
                                               style="flex-direction: column;
                                                        box-sizing: border-box;
                                                        display: flex;
                                                        flex: 1 1 10.3em;
                                                        max-width: 10.3em;
                                                        min-width: 10.3em;">
                            </logzy-money-field>
                        </span>
                    </mat-cell>
                    <mat-footer-cell *matFooterCellDef="let data"></mat-footer-cell>
                </ng-container>
                <ng-container matColumnDef="rec_total">
                    <mat-header-cell *matHeaderCellDef>Total (Rec)</mat-header-cell>
                    <mat-cell *matCellDef="let data; let index = index">
                        <span>{{ data.rec_total + ' ' + data.rec_currency }}</span>
                    </mat-cell>
                    <mat-footer-cell *matFooterCellDef="let data">
                        <!--                                    <span> Total: {{-->
                        <!--                                            getTotalRec()-->
                        <!--                                        }} </span>-->
                    </mat-footer-cell>
                </ng-container>
                <ng-container matColumnDef="rec_remark">
                    <mat-header-cell *matHeaderCellDef>Remark (Rec)</mat-header-cell>
                    <mat-cell *matCellDef="let data; let index = index">
                        <span class="line-clamp" style="width: 9em;">
<!--                            {{ data.rec_remarks }}-->
                            <app-text-field [isMultiline]="true" [isEditable]="true" [(ngModel)]="data.rec_remarks"
                                            [name]="'rec_remarks'" [errors]="errorObj.rec_remarks">
                            </app-text-field>
                        </span>
                    </mat-cell>
                    <mat-footer-cell *matFooterCellDef="let data"></mat-footer-cell>
                </ng-container>
                <ng-container matColumnDef="pay_amount">
                    <mat-header-cell *matHeaderCellDef>Pay Amt/Qty</mat-header-cell>
                    <mat-cell *matCellDef="let data; let index = index" style="overflow: visible;">
                        <span>
<!--                            {{ data.pay_amount + ' ' + data.pay_currency }}-->
                            <logzy-money-field [isEditable]="true" [(amount)]="data.pay_amount"
                                               [minValue]="0" (amountChange)="setPayTotal(data)"
                                               [maxValue]="999999999" [(currencyCode)]="data.pay_currency"
                                               (currencyCodeChange)="updateChargesCurrency(data)"
                                               style="flex-direction: column;
                                                        box-sizing: border-box;
                                                        display: flex;
                                                        flex: 1 1 10.3em;
                                                        max-width: 10.3em;
                                                        min-width: 10.3em;">
                            </logzy-money-field>
                        </span>
                    </mat-cell>
                    <mat-footer-cell *matFooterCellDef="let data"></mat-footer-cell>
                </ng-container>
                <ng-container matColumnDef="paid_to">
                    <mat-header-cell *matHeaderCellDef>Paid To</mat-header-cell>
                    <mat-cell *matCellDef="let data; let index = index" style="overflow: visible;">
                        <span style="min-width: 9em; max-width: 9em;">
<!--                            {{ data.paid_to?.legal_name }}-->
                            <app-mat-auto-search [isEditable]="true"
                                                 [(ngModel)]="data.paid_to" [name]="'paid_to'"
                                                 [displayField]="'legal_name'"
                                                 [labelItemTemplate]="userSelectedItemPaid"
                                                 [itemTemplate]="userItemPaid"
                                                 [idField]="null" [listUrl]="company_url+'?name=::search::'"
                                                 fxLayout="column">
                            </app-mat-auto-search>
                        </span>
                    </mat-cell>
                    <mat-footer-cell *matFooterCellDef="let data"></mat-footer-cell>
                </ng-container>
                <ng-container matColumnDef="pay_remark">
                    <mat-header-cell *matHeaderCellDef>Remark (Pay)</mat-header-cell>
                    <mat-cell *matCellDef="let data; let index = index">
                        <span class="line-clamp" style="width: 9em;">
<!--                            {{ data.pay_remarks }}-->
                            <app-text-field [isMultiline]="true" [isEditable]="true" [(ngModel)]="data.pay_remarks"
                                            [name]="'rec_remarks'" [errors]="errorObj.pay_remarks">
                            </app-text-field>
                        </span>
                    </mat-cell>
                    <mat-footer-cell *matFooterCellDef="let data"></mat-footer-cell>
                </ng-container>
                <ng-container matColumnDef="pay_total">
                    <mat-header-cell *matHeaderCellDef>Total (Pay)</mat-header-cell>
                    <mat-cell *matCellDef="let data; let index = index">
                        <span>{{ data.pay_total + ' ' + data.pay_currency }}</span>
                    </mat-cell>
                </ng-container>
                <!--                <ng-container matColumnDef="actions">-->
                <!--                    <mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>-->
                <!--                    <mat-cell *matCellDef="let data; let index = index">-->
                <!--                        <div class="d-flex">-->
                <!--                            <button mat-icon-button class="delete-button" matTooltip="Delete"-->
                <!--                                    matTooltipPosition="right"-->
                <!--                                    color="warn" (click)="deleteCharge(index)">-->
                <!--                                <i class="flaticon-delete"></i>-->
                <!--                            </button>-->
                <!--                        </div>-->
                <!--                    </mat-cell>-->
                <!--                </ng-container>-->
                <mat-header-row *matHeaderRowDef="displayedColumnsCharges ; sticky: true "></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumnsCharges;"
                         [hidden]="chargesDataSource.data.length == 0"></mat-row>
            </mat-table>
        </div>
    </div>
    <!--    <ng-container>-->
    <!--        <div class="vstack " [class.gap-2]="tncExpand">-->
    <!--            <div class="HeaderSet">-->
    <!--                <span class="editHead editHeadCursor">-->
    <!--                    Terms and Conditions-->
    <!--                </span>-->
    <!--            </div>-->
    <!--            <div class="additionalDetails " [class.viewExpand]="tncExpand">-->
    <!--                <app-select-field [isEditable]="!isCustomer && negotiate"-->
    <!--                                  [hidden]="isCustomer || termsConditionList?.length == 1" [name]="'termsCondition'"-->
    <!--                                  [displayField]="'name'" [(ngModel)]="termsAndCondition"-->
    <!--                                  [options]="termsConditionList"-->
    <!--                                  fxLayout="column" fxFlex="12em" (ngModelChange)="showSelectedTermsAndCondition()"-->
    <!--                                  [(errors)]="emptyRepoQuoteTableService.baseQuote.error.terms_and_condition_fk">-->
    <!--                </app-select-field>-->
    <!--                <quill-editor *ngIf="!isCustomer" [styles]="{'min-height': '50px'}"-->
    <!--                              [(ngModel)]="selectedTermsAndCondition" id="termsAndCondition" [modules]="modules"-->
    <!--                              #editor-->
    <!--                              placeholder="Enter Terms and Conditions ....." style="width: inherit;">-->
    <!--                </quill-editor>-->
    <!--                <quill-view *ngIf="isCustomer" [content]="selectedTermsAndCondition" format="html" theme="snow"-->
    <!--                            style="overflow: auto;     border: 1px solid #d5d5d5;  width: 100%;"></quill-view>-->
    <!--            </div>-->
    <!--        </div>-->
    <!--    </ng-container>-->
    <ng-container>
        <div fxFlex="100" class="btnb" fxLayout="row wrap"
             *ngIf="requestService.selectedRequest?.status?.dev_name != 'quote_accepted_by_external_user'">
            <button class="loadingBtn Save" mat-raised-button [disabled]="disableSaveButton || !negotiate"
                    (click)="saveQuotation()">
                <span *ngIf="!disableSaveButton"> Save Booking </span>
                <div *ngIf="disableSaveButton" class="p03">
                    <i class="flaticon-loading spin"></i>
                    <span>Saving...</span>
                </div>
            </button>
        </div>
    </ng-container>
    <ng-container>
        <div class="vstack " [class.gap-2]="uploadDocExpand">
            <div class="HeaderSet">
                <span class="editHead editHeadCursor" (click)="uploadDocExpand = !uploadDocExpand">
                    Comments/Attachments
                    <i class="flaticon-down-chevron" [ngClass]="uploadDocExpand? 'more':'' "></i>
                </span>
            </div>
            <div class="additionalDetails" [class.viewExpand]="uploadDocExpand">
                <mat-tab-group animationDuration="1500ms">
                    <mat-tab label="Comments">
                        <div class="additionalDetails" [class.viewExpand]="remarkExpand">
                            <logzy-quote-remarks fxLayout="row wrap">
                            </logzy-quote-remarks>
                        </div>
                    </mat-tab>
                    <mat-tab label="Attachments">
                        <div class="mnrList">
                            <logzy-request-documents fxFlex="100"></logzy-request-documents>
                        </div>
                    </mat-tab>
                </mat-tab-group>
            </div>
        </div>
    </ng-container>
</ng-container>

<ng-template #userItem let-item let-index>
    <div fxFlex=" 100" fxLayout="column" class="managerListShow">
        <span class="fullname">
            {{ item?.charge?.print_name }}
        </span>
        <span class="email">
            {{ item?.charge?.charge_code }}
        </span>
    </div>
</ng-template>

<ng-template #userSelectedItem let-item>
    {{ item?.charge?.print_name }}
</ng-template>

<ng-template #userItemPaid let-item let-index>
    <div fxFlex=" 100" fxLayout="column" class="managerListShow">
        <span class="fullname">
            {{ item?.legal_name }}
        </span>
        <span class="email">{{ item?.address }}
        </span>
    </div>
</ng-template>

<ng-template #userSelectedItemPaid let-item>
    {{ item?.legal_name }}
</ng-template>

<ng-template #userChargeItem let-item let-index>
    <div fxFlex=" 100" fxLayout="column" class="managerListShow">
        <span class="fullname">
            {{ item?.charge?.charge_head }}
        </span>
        <span class="email">
            {{ item?.charge?.hsn_code?.code }}
        </span>
    </div>
</ng-template>

<ng-template #userChargeSelectedItem let-item>
    {{ item?.charge?.charge_head }}
</ng-template>

<ng-template #requirementItem let-item let-index>
    <div fxFlex=" 100" fxLayout="column" class="managerListShow">
        <span class="fullname">
            {{ item?.container_size_type?.display }}
        </span>
        <!--        <span class="email">-->
        <!--            {{ item?.charge?.hsn_code?.code }}-->
        <!--        </span>-->
    </div>
</ng-template>

<ng-template #requirementSelectedItem let-item>
    {{ item?.container_size_type?.display }}
</ng-template>
